module.exports = __webpack_public_path__ + "img/wallet.2592ea66.svg";